/* eslint-disable react/jsx-props-no-spreading, react/prop-types, import/no-cycle */
import React from 'react';
import LandingBanner from './blocks/landing-banner';
import ProductBanner from './blocks/product-banner';
import TitleContentListImage from "./blocks/title-content-list-image";
import AwardsCta from "./blocks/awards-cta";
import TitleCardItem from "./blocks/title-card-item";
import TitleBrandItem from './blocks/title-brand-items';
import TitleClient from "./blocks/title-client";
import BannerCta from "./blocks/banner-cta";
import TitleHeader from "./blocks/title-header";
import ImageHeader from "./blocks/image-header";
import TeamArchive from "./blocks/team-archive";
import DistributorArchive from "./blocks/distributor-archive";
import ExpertiseBanner from "./blocks/expertise-banner";
import TitleContentImage from "./blocks/title-content-image";
import Testimonial from "./blocks/testimonial";
import Partnership from "./blocks/partnership";
import TitleContentVideo from "./blocks/title-content-video";
import TitleVideo from "./blocks/title-video";
import TitleContentItems from "./blocks/title-content-items";
import StatsItem from "./blocks/stats-item";
import SunnyPromoBanner from './blocks/sunny-promo-banner';
import ArticleArchive from "./blocks/article-archive";
import RecipeArchive from "./blocks/recipe-archive";
import RecipeSelector from "./blocks/recipe-selector";
import ProductArchive from "./blocks/product-archive";
import BasicCta from "./blocks/basic-cta";
import ReplicaLabel from './blocks/replica-label';
import TitleContentImageButton from "./blocks/title-content-image-button";
import StickyCard from "./blocks/sticky-card";
import TitleGallery from "./blocks/title-gallery";
import ImageBanner from "./blocks/image-banner";
import TeamSelector from "./blocks/team-selector";
import MapLottie from "./blocks/map-lottie";
import Contact from "./blocks/contact";
import ProductCta from "./blocks/product-cta";
import Timeline from "./blocks/timeline";
import RequestSample from './blocks/request-sample';
import ThankYou from './blocks/thank-you';
import ThreeColumnItem from "./blocks/three-column-item";
import RangeSliderItem from "./blocks/range-slider-item";
import TitleContentCategory from "./blocks/title-content-category";
import TitleContentVideoItem from "./blocks/title-content-video-item";
import NewProduct from './blocks/new-product';
import Promo from './blocks/promo';
import QuoteContent from "./blocks/quote-content";
import CampaignContent from "./blocks/campaign-content";
import CampaignVideo from './blocks/campaign-video';
import SunnysideQuality from './blocks/sunnyside-quality';
import BasicPage from './blocks/basic-page';
import EmptyBlock from './blocks/empty-block';
import FoodServiceChef from './blocks/food-service-chef';
import ImageContentCta from './blocks/image-content-cta';
import BurgerCampaign from './blocks/burger-campaign';
import BurgerColumnItem from './blocks/burger-column-item';
import TitleContentImageItem from './blocks/title-content-image-item';
import Linktree from './blocks/linktree';
import ImageIconContent from './blocks/image-icon-content';
import TitleContentColumn from './blocks/title-content-column';
import TitleContentSticky from './blocks/title-content-sticky';
import SustainLanding from './blocks/sustain-landing';
import ScrollCard from './blocks/scroll-card';
import ContentClientImage from './blocks/content-client-image';
import PromoLanding from './blocks/promo-landing';
import PromoForm from './blocks/promo-form';
import PromoThreeColumn from './blocks/promo-three-column';
import CampaignTitleGalleryContent from './blocks/campaign-title-gallery-content';
import CampaignTitleContentImage from './blocks/campaign-title-content-image';
import { useDebug, DebugPill } from "../../../plugins/gatsby-plugin-atollon";

/*
* Context for retaining render depth
* */
export const BlockRendererContext = React.createContext(-1);

export const RenderBlock = ({ __typename, ...props }) => {
    switch (__typename.replace('DatoCms', '')) {
        case 'LandingBanner':
            return <LandingBanner {...props} />;
        case 'ProductBanner':
            return <ProductBanner {...props} />;
        case 'NewProduct':
            return <NewProduct {...props} />;
        case 'Promo':
            return <Promo {...props} />;
        case 'ReplicaLabel':
            return <ReplicaLabel {...props} />;
        case 'TitleContentListImage':
            return <TitleContentListImage {...props} />;
        case 'AwardsCta':
            return <AwardsCta {...props} />;
        case 'TitleCardItem':
            return <TitleCardItem {...props} />;
        case 'TitleBrandItem':
            return <TitleBrandItem {...props} />;
        case 'TitleClient':
            return <TitleClient {...props} />;
        case 'BannerCta':
            return <BannerCta {...props} />;
        case 'TitleHeader':
            return <TitleHeader {...props} />;
        case 'TeamArchive':
            return <TeamArchive {...props} />;
        case 'DistributorArchive':
            return <DistributorArchive {...props} />;
        case 'ExpertiseBanner':
            return <ExpertiseBanner {...props} />;
        case 'ImageHeader':
            return <ImageHeader {...props} />;
        case 'TitleContentImage':
            return <TitleContentImage {...props} />;
        case 'Testimonial':
            return <Testimonial {...props} />;
        case 'Partnership':
            return <Partnership {...props} />;
        case 'TitleContentVideo':
            return <TitleContentVideo {...props} />;
        case 'TitleVideo':
            return <TitleVideo {...props} />;
        case 'TitleContentItem':
            return <TitleContentItems {...props} />;
        case 'StatsItem':
            return <StatsItem {...props} />;
        case 'ArticleArchive':
            return <ArticleArchive {...props} />;
        case 'RecipeArchive':
            return <RecipeArchive {...props} />;
        case 'RecipeSelector':
            return <RecipeSelector {...props} />;
        case 'SunnyPromoBanner':
            return <SunnyPromoBanner {...props} />;
        case 'BasicPage':
            return <BasicPage {...props} />;
        case 'ProductArchive':
            return <ProductArchive {...props} />;
        case 'BasicCta':
            return <BasicCta {...props} />;
        case 'TitleContentImageButton':
            return <TitleContentImageButton {...props} />;
        case 'StickyCard':
            return <StickyCard {...props} />;
        case 'TitleGallery':
            return <TitleGallery {...props} />;
        case 'ImageBanner':
            return <ImageBanner {...props} />;
        case 'TeamSelector':
            return <TeamSelector {...props} />;
        case 'MapLottie':
            return <MapLottie {...props} />;
        case 'Contact':
            return <Contact {...props} />;
        case 'CampaignVideo':
            return <CampaignVideo {...props} />;
        case 'ProductCta':
            return <ProductCta {...props} />;
        case 'Timeline':
            return <Timeline {...props} />;
        case 'RequestSample':
            return <RequestSample {...props} />;
        case 'ThankYou':
            return <ThankYou {...props} />;
        case 'ThreeColumnItem':
            return <ThreeColumnItem {...props} />;
        case 'RangeSliderItem':
            return <RangeSliderItem {...props} />;
        case 'TitleContentCategory':
            return <TitleContentCategory {...props} />;
        case 'TitleContentVideoItem':
            return <TitleContentVideoItem {...props} />;
        case 'QuoteContent':
            return <QuoteContent {...props} />;
        case 'CampaignContent':
            return <CampaignContent {...props} />;
        case 'CampaignTitleGalleryContent':
            return <CampaignTitleGalleryContent {...props} />;
        case 'CampaignTitleContentImage':
            return <CampaignTitleContentImage {...props} />;
        case 'SunnysideQuality':
            return <SunnysideQuality {...props} />;
        case 'FoodServiceChef':
            return <FoodServiceChef {...props} />;
        case 'TitleContentImageItem':
            return <TitleContentImageItem {...props} />;
        case 'ImageContentCta':
            return <ImageContentCta {...props} />;
        case 'BurgerCampaign':
            return <BurgerCampaign {...props} />;
        case 'BurgerColumnItem':
            return <BurgerColumnItem {...props} />;
        case 'Linktree':
            return <Linktree {...props} />;
        case 'SustainLanding':
            return <SustainLanding {...props} />;
        case 'ContentClientImage':
            return <ContentClientImage {...props} />;
        case 'ImageIconContent':
            return <ImageIconContent {...props} />;
        case 'ScrollCard':
            return <ScrollCard {...props} />;
        case 'TitleContentColumn':
            return <TitleContentColumn {...props} />;
        case 'TitleContentSticky':
            return <TitleContentSticky {...props} />;
        case 'ScrollCard':
            return <ScrollCard {...props} />;
        case 'ContentClientImage':
            return <ContentClientImage {...props} />;
        case 'PromoLanding':
            return <PromoLanding {...props} />;
        case 'PromoForm':
            return <PromoForm {...props} />;
        case 'PromoThreeColumn':
            return <PromoThreeColumn {...props} />;
        default:
            return <EmptyBlock>{__typename}</EmptyBlock>;
    }
};

const BlockRenderer = ({ data, className, brand }) => {
    const { showBlockNames } = useDebug();
    const existingRenderContextDepth = React.useContext(BlockRendererContext);

    return (
        <BlockRendererContext.Provider value={existingRenderContextDepth + 1}>
            {data && data.map((block, i) => {
                const { __typename: blockType } = block;

                if (!blockType) {
                    throw new Error("You must source __typename on every blocks field.")
                }

                return (
                    <RenderBlock
                        key={block.id}
                        className={className}
                        theme={brand}
                        {...block}
                    />
                );
            })}
        </BlockRendererContext.Provider>
    );
};

export default BlockRenderer;
